import React, { JSX } from "react";
import { QRCodeSVG } from "qrcode.react";

interface QrProps {
  value: string;
  size?: number;
}

const Qr = ({ value, size = 180 }: QrProps): JSX.Element => (
  <QRCodeSVG
    value={value}
    size={size}
    bgColor="#ffffff"
    fgColor="#000000"
    level="L"
    includeMargin={false}
  />
);

export default Qr;
